<template>
  <div id="app">
    <Navbar />
    <router-view class="router-view"></router-view>
    <FooterView />
  </div>
</template>

<script>
import Navbar from "@/components/global/Navbar";
import FooterView from "@/components/global/FooterView";

export default {
  name: "app",
  components: { Navbar, FooterView },
  data: () => ({
    marathon: {
      mode: "post-marathon",
      name: "Tomb Raider Marathon VII",
      id: 7,
      charity: "Direct Relief",
      charity_url: "https://directrelief.org/",
      starts: "21st November 2020, 10am EST",
      starts_iso: "2020-11-21T15:00:00+00:00",
      starts_unix: new Date("2020-11-21T15:00:00+00:00").getTime() / 1000,
      latestVideo:
        "https://player.twitch.tv/?autoplay=false&collection=ANcPcRZ7ShY0QQ",
    },
    social: [
      { link: "https://twitch.tv/tombraidermarathon", platform: "Twitch" },
      { link: "http://discord.tombraidermarathon.com", platform: "Discord" },
      { link: "https://twitter.com/tombraiderthon", platform: "Twitter" },
      { link: "https://facebook.com/tombraiderthon", platform: "Facebook" },
    ],
  }),

  methods: {
    setPageTitle(title) {
      document.getElementsByTagName(
        "title"
      )[0].innerText = `Tomb Raider Marathon - {$title}`;
    },
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/base/_all";
@import "~bulma/sass/grid/columns";
@import "~bulma/sass/elements/container";
@import "~bulma/sass/elements/title";
@import "~bulma/sass/elements/content";
@import "~bulma/sass/elements/other";
@import "~bulma/sass/components/modal";
@import "~bulma/sass/layout/hero";

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  & > .router-view {
    flex: 1;

    @media screen and (max-width: $phone-size) {
      padding-top: $navbar-height;
    }
  }

  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app,
#app * {
  box-sizing: border-box;
}

* {
  list-style: none;
  margin: 0;
  outline: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?92abfca8